package com.clany.backoffice.domain.usecase

import com.clany.backoffice.domain.repository.SubscriptionRepository
import com.clany.backoffice.model.SubscriptionResponse
import dev.zacsweers.metro.Inject

class GetSubscriptionsUseCase @Inject constructor(
    private val repository: SubscriptionRepository
) {
    suspend operator fun invoke(
        page: Int = 1,
        pageSize: Int = 20,
        query: String? = null
    ): Result<List<SubscriptionResponse>> = repository.getSubscriptions(page, pageSize, query)
}
